if (!customElements.get('multicolumn-carousel-slider')) {
  customElements.define(
    'multicolumn-carousel-slider',
    class multicolumnCarouselSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn-carousel-slider__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination'
        };

        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.enableSlider = this.dataset.enableSlider === 'true';

        this.sliderInstance = false;

        if (!this.enableSlider) return;
        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        this.initSlider();
        this.calculateItemsWidth();
      }

      initSlider() {
        const mobileCols = parseInt(document.getElementById('custom_columns_mobile')?.value) || 1.5;
        const desktopCols = parseInt(document.getElementById('custom_columns_desktop')?.value) || 4.2;

        const isMobile = window.innerWidth < 768;
        const slidesPerViewValue =
        isMobile
          ? (mobileCols === 1 ? 1.5 : mobileCols)
          : desktopCols;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: isMobile ? 20 : 24,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
            clickable: true,
          },
          loop: false,
          threshold: 2,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          watchSlidesProgress: true,
          breakpoints: {
             0: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 4.2,
                spaceBetween: 24,
            },
          }
        };

        if (typeof this.sliderInstance !== 'object') {
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();

          this.sliderInstance.slider.on('slideChange', () => {
            const pagination = this.section.querySelector('.swiper-pagination-slider');
            const activeBullet = pagination?.querySelector('.swiper-pagination-bullet-active');

            if (activeBullet) {
              activeBullet.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest',
              });
            }
          });

          // const focusableElements = FoxTheme.a11y.getFocusableElements(this);

          // focusableElements.forEach((element) => {
          //   element.addEventListener('focusin', () => {
          //     const slide = element.closest('.swiper-slide');
          //     this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          //   });
          // });
        }
        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calculateItemsWidth() {
        Array.from(this.sliderWrapper.children).forEach((item) => {
          const width = item.dataset.width;
          const widthMobile = item.dataset.widthMobile;
          item.style.setProperty('--item-width', width);
          item.style.setProperty('--item-width-mobile', widthMobile);
        });
      }
    }
  );
}

if (!customElements.get('multicolumn-carousel-scroll-progress-bar')) {
  customElements.define(
    'multicolumn-carousel-scroll-progress-bar',
    class multicolumnCarouselScrollProgressBar extends ScrollProgressBar {
      get totalWidth() {
        this.allChildren = this.target.children;

        let totalWidth = 0;
        [...this.allChildren].forEach((child) => {
          totalWidth += child.offsetWidth;
        });

        return totalWidth;
      }
    }
  );
}